import { styled } from 'styled-components';

const S = {
  Container: styled.div`
    margin-top: 70px;
    width: calc(100vw - 350px);
    height: calc(100vh - 70px);
    display: flex;
  `
};

export { S };
